// src/context/ThemeContext.js
import React, { createContext, useState, useContext } from 'react';
import { defaultTheme, darkTheme, lightTheme } from '../styles/themes/defaultTheme';

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState('default');
  const [themeConfig, setThemeConfig] = useState(defaultTheme);

  const changeTheme = (themeName) => {
    switch (themeName) {
      case 'dark':
        setThemeConfig(darkTheme);
        setTheme('dark');
        break;
      case 'light':
        setThemeConfig(lightTheme);
        setTheme('light');
        break;
      default:
        setThemeConfig(defaultTheme);
        setTheme('default');
    }
  };

  return (
    <ThemeContext.Provider value={{ theme, themeConfig, changeTheme }}>
      <div data-bs-theme={theme}>
        {children}
      </div>
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};